// extracted by mini-css-extract-plugin
module.exports = {"strokeMarketplaceColor":"IconKeys_strokeMarketplaceColor__2wv_O"};